module.exports = __webpack_public_path__ + "img/Weilin Vision Car Light Inspection.fe59225c.jpg";